import { LOGGER } from "../utils/logger";
import useAxios from "../utils/interceptor";

const MediaApi = () => {
  const axiosHandler = useAxios();

  const getAllPaginated = async ({ page = 0, pageSize = 10, type = "" }) => {
    try {
      const res = await axiosHandler.get(
        `media/paginated?page=${page}&pageSize=${pageSize}&type=${type}`
      );
      return res?.data?.data;
    } catch (error) {
      LOGGER.error({ text: "getAll api ", error });
    }
  };

  const create = async (body) => {
    try {
      const res = await axiosHandler.post(`media`, body);
      console.log(res);
      return res;
    } catch (error) {
      LOGGER.error({ text: "create api ", error });
      return {
        text: "create api error",
        error,
      };
    }
  };

  const remove = async (id) => {
    try {
      const res = await axiosHandler.delete(`media/${id}`);
      return res;
    } catch (error) {
      LOGGER.error({ text: "create api ", error });
      return {
        text: "create api error",
        error,
      };
    }
  };

  return { create, getAllPaginated, remove };
};

export default MediaApi;
